import {GameColor} from '../../../../shared/scripts/GameColor'
import {UIGameCardContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardContainerView'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupSelectCardToGiveToAnotherPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCardToGiveToAnotherPlayer'

export class UIMGamePopupSelectCardToGiveToAnotherPlayer extends UIGamePopupSelectCardToGiveToAnotherPlayer {
    protected createSelectedCardContainer() {
        const w = this.canvas.popupWidth
        const h = this.canvas.itemSize * 1.2
        const selectCardContainerY = this.popupImageAndDescription.y + this.popupImageAndDescription.height
        this.selectedCardContainer = new UIGameCardContainerView(this.uiGameManager, 0, selectCardContainerY, w, h, this)
    }

    protected createConfirmationButtons() {
        const clickedCheckAction = () => this.checkAction()
        const clickedCancelAction = () => undefined

        const w = this.canvas.popupWidth
        const bottomButtonH = this.canvas.itemSize
        const bottomButtonY = this.absoluteHeight
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, bottomButtonY, w, bottomButtonH, clickedCheckAction, clickedCancelAction, this)
        this.selectCardFormat.selectCardFormat.cancelButtonActive ? this.confirmationButtons.showCancelButton() : this.confirmationButtons.hideCancelButton()
    }

    protected setContainerY() {
        const canvas = this.uiGameManager.canvasController
        const spaceFromBottom = canvas.bottomViewHeight
        this.y = this.canvas.appH - spaceFromBottom - this.absoluteHeight
    }

    protected createPlayerCardContainer() {
        const canvas = this.uiGameManager.canvasController
        const playerCardContainerX = 0
        const playerCardContainerH = this.canvas.itemSize * 1.25
        const playerCardContainerY = this.height + canvas.margin
        const playerCardContainerW = this.width

        this.playerCardContainer = new UIGameCardContainerView(this.uiGameManager, playerCardContainerX, playerCardContainerY, playerCardContainerW, playerCardContainerH, this, false, false)
        this.playerCardContainer.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6), 1)
    }
}
